import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'brl' })
export class BrCurrencyPipe extends CurrencyPipe implements PipeTransform {
  override transform(value: any, args?: any): any {
    if (!value) value = 0;
    const currency = super.transform(value, 'BRL');
    const splitted = currency?.split('.');
    return splitted[0].replace(',', '.') + ',' + splitted[1].replace('.', ',');
  }
}

@Pipe({ name: 'truncate', pure: true })
export class TruncatePipe implements PipeTransform {
  transform(value: number | null | undefined, decimals = 2): number {
    const v = Number(value ?? 0);
    const f = Math.pow(10, decimals);
    return Math.trunc(v * f) / f;
  }
}
